import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/rightside_arrow.svg';

const RightSideArrow = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};

export default RightSideArrow;
